import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import ProductImageThumbnail    from './product-image-thumbnail';
import classNames from 'classnames';
import Carousel from '../_common/carousel';
import PreviewImage from './preview-image';

// -----------------------------------------------------------
//  ProductImages
// -----------------------------------------------------------
class ProductImages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      id: this.props.product.id,
    };
  }
  render() {
    if (!this.props.product) {
      return null;
    }

    const {
      modal,
      product: {
        theme_and_product_images: productImages
      }
    } = this.props;
    
    if (productImages.length == 0) {
      return null;
    }

    const slickSettings = {
      arrows: false,
      infinite: true,
      speed: 300,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    }

    const isMobile = (() => {
      if (typeof document !== 'undefined') {
        return document.documentElement.clientWidth < 768;
      }
  
      return false;
    })();
    
    // key is used to reset the state back to zero when the selected product changes
    if (isMobile) {
      const carouselImages = productImages.map((productImage, i) => {
        return <PreviewImage key={'carousel-image-' + i} asset={productImage} index={i} {...this.props}/>
      });

      return (
        <div>
          <Carousel
            id={this.state.id}
            slickSettings={slickSettings}
          >
            {carouselImages}
          </Carousel>
        </div>
      );
    } else {
      return (
        <div className="thumbnails-wrapper row">
          {this.renderThumbnails()}
          <div className={classNames("preview-image col-10 col-lg-10 col-md-9 p-0 justify-content-center", {'trimmed-edges mx-auto': this.props.elegant_corners || this.props.scalloped_edges}, {'d-flex': modal})}>
            { <PreviewImage asset={productImages[this.state.index]} index={this.state.index} {...this.props}/> }
          </div>
        </div>
      );
    }
  }
  renderThumbnails() {
    const attributes = {
      isRounded:   this.props.rounded_corners,
      isElegant:   this.props.elegant_corners,
      isScalloped: this.props.scalloped_edges,
      isCard:      this.props.product.is_card
    };
    const {
      selectedTheme,
      modal,
      product: {
        title: productTitle,
        theme_and_product_images: productImages
      }
    } = this.props;

    if (productImages.length < 2) return null;

    const alt = selectedTheme ? `${productTitle} with ${selectedTheme.title} design` : productTitle;
    const amountOfThumbnailsToShow = modal ? productImages.length : 6;
    const thumbnails = productImages.slice(0, amountOfThumbnailsToShow);
    const viewAllButton = () => {
      const viewAll = productImages.length - thumbnails.length;
      return (
        <button className='d-flex flex-wrap flex-column justify-content-center p-0 btn view-all'
          onClick={() => this.props.viewAll(true)}>
          <span className='number'>+{viewAll}</span>
          <span className='view-all'>View All</span>
        </button>
      );
    };
    return (
      <ul className={classNames("col-2 col-lg-2 col-md-3 list-inline thumbnails p-0 d-flex flex-column flex-wrap align-content-center", {'overflow-auto': modal})} role="radiogroup">
        {
          thumbnails.map((productImage, i) => {
            const showViewAll = (i == 5 && productImages.length > amountOfThumbnailsToShow && !modal);

            return (
              <li className={classNames("list-inline-item", {"show-more position-relative": showViewAll})} key={ i }>
                <ProductImageThumbnail key={i}
                                       { ...productImage }
                                       { ...attributes }
                                       alt={`Thumbnail for ${alt} ${i + 1}`}
                                       index={i}
                                       selected={i == this.state.index}
                                       onClick={this.handleSelected}
                                       optionAsset={this.customisationOptionAsset()}
                                       tabIndex={showViewAll ? '-1' : '0'} />
                { showViewAll && viewAllButton() }
              </li>
            );
          })
        }
      </ul>
    )
  }
  customisationOptionAsset = () => {
    const {index} = this.state;
    const {selectedOptions = {}, productOptions = []} = this.props;
    const [{id, display_overlay_preview: displayOverlayPreview} = {}] = productOptions;
    const {[id]: {asset} = {} } = {} = selectedOptions;

    return index === 0 && displayOverlayPreview ? asset : undefined;
  }
  handleSelected = (index) => {
    this.setState(prevState => {
      if (index != prevState.index)
        return {
          index
        };
    });
  }
};

export default ProductImages;
